import React, {useState} from "react";
import Styles from './styles.module.scss';
import {useDispatch, useSelector} from "react-redux";
import Moment from "react-moment";

import arrow from '../../theme/assets/svg/ftf_transaction_arrow.svg';
import {getTransactions} from "../../store/cabinet/action";
import {useTranslation} from "react-i18next";



const CabinetTransactionsMain = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const transactions = useSelector(store => store.cabinet.transactions);

    const [currentFilterIndex, setCurrentFilterIndex] = useState(0);
    const [filterDropStatus, setFilterDropStatus] = useState(false);

    const availableFilters = ['All', 'Referral', 'Contest', 'Matrix', 'Events']

    const categoryContentHandler = (category) =>{
        switch (category){
            case 'matrix':
                return 'Matrix';
            default:
                return 'Unknown';
        }
    }

    const typeContentHandler = (type) =>{
        switch (type){
            case 'refill':
                return t('Пополнение');
            case 'withdraw':
                return t('Вывод');
            default:
                return 'Unknown';
        }
    }

    const statusContentHandler = (status) =>{
        switch (status){
            case 'create':
                return t('Создан');
            case 'confirmed':
                return t('Подтвержден');
            default:
                return 'Unknown';
        }
    }

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.ftfCard}`}>
                <div className={`${Styles.titleRow}`}>
                    <div className={`${Styles.title}`}>{t('Транзакции')}</div>
                    <div className={`${Styles.filterWrap}`}>
                        <div className={`${Styles.filterWrapCurrent}`} onClick={()=>{setFilterDropStatus(!filterDropStatus)}}>
                            <div className={`${Styles.filter}`}>{availableFilters[currentFilterIndex]}</div>
                            <div className={`${Styles.arrowWrap} ${filterDropStatus ? Styles.arrowWrapActive : null}`}><img src={arrow} alt="filter drop arrow"/></div>
                        </div>
                        <div className={`${Styles.filterBox} ${filterDropStatus ? Styles.filterBoxActive : null}`}>
                            {availableFilters.map((item, index)=>{
                                return (
                                    <div
                                        className={`${Styles.filterBoxItem} ${currentFilterIndex === index ? Styles.filterBoxItemActive : null}`}
                                        key={'transactionFilter' + index}
                                        onClick={()=>{
                                            setCurrentFilterIndex(index);
                                            dispatch(getTransactions(index === 0 ? false : availableFilters[index].toLowerCase()))
                                            setFilterDropStatus(false);
                                        }}
                                    >
                                        {item}
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
                <div className={`${Styles.tableWrap}`}>
                    <div className={`${Styles.tableWrapTitleRow}`}>
                        <div className={`${Styles.tableWrapTitleRowItem}`}>{t('Дата')}</div>
                        <div className={`${Styles.tableWrapTitleRowItem}`}>{t('Категория')}</div>
                        <div className={`${Styles.tableWrapTitleRowItem}`}>{t('Сумма')}</div>
                        <div className={`${Styles.tableWrapTitleRowItem}`}>{t('Тип')}</div>
                        <div className={`${Styles.tableWrapTitleRowItem}`}>{t('Статус')}</div>
                    </div>
                    <div className={`${Styles.tableBox}`}>
                        {transactions?.transactions?.data?.length > 0 ? transactions.transactions.data.map((item, index)=>{
                            return (
                                <div className={`${Styles.tableBoxItem}`} key={'transactionItem' + index}>
                                    <div className={`${Styles.tableBoxItemRow}`}>
                                        <div className={`${Styles.tableBoxItemMobileTitle}`}>Date</div>
                                        <div className={`${Styles.tableBoxItemValue}`}>
                                            <div className={`${Styles.tableBoxItemValueDateDay}`}><Moment format="DD.MM.YYYY">{item.created_at}</Moment></div>
                                            <div className={`${Styles.tableBoxItemValueDateHour}`}><Moment format="hh:mm">{item.created_at}</Moment></div>
                                        </div>
                                    </div>
                                    <div className={`${Styles.tableBoxItemRow}`}>
                                        <div className={`${Styles.tableBoxItemMobileTitle}`}>Category</div>
                                        <div className={`${Styles.tableBoxItemValue}`}>{categoryContentHandler(item.category)}</div>
                                    </div>
                                    <div className={`${Styles.tableBoxItemRow}`}>
                                        <div className={`${Styles.tableBoxItemMobileTitle}`}>Amount</div>
                                        <div className={`${Styles.tableBoxItemValue} ${Styles.colorYellow}`}>{item.amount * 1} {item.currency.code}</div>
                                    </div>
                                    <div className={`${Styles.tableBoxItemRow}`}>
                                        <div className={`${Styles.tableBoxItemMobileTitle}`}>Type</div>
                                        <div className={`${Styles.tableBoxItemValue}`}>{typeContentHandler(item.type)}</div>
                                    </div>
                                    <div className={`${Styles.tableBoxItemRow}`}>
                                        <div className={`${Styles.tableBoxItemMobileTitle}`}>Status</div>
                                        <div className={`${Styles.tableBoxItemValue}`}>{statusContentHandler(item.status)}</div>
                                    </div>
                                </div>
                            )
                        }) : <div className={`${Styles.emptyMsg}`}>There are currently no transactions!</div>}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CabinetTransactionsMain;